const EVENT_KEY = 'app:toast';

export const toast = {
  success: (message) => window.dispatchEvent(new CustomEvent(EVENT_KEY, { detail: { message, type: 'success' } })),
  error: (message) => window.dispatchEvent(new CustomEvent(EVENT_KEY, { detail: { message, type: 'error' } })),
  info: (message) => window.dispatchEvent(new CustomEvent(EVENT_KEY, { detail: { message, type: 'info' } })),
};

export { EVENT_KEY as TOAST_EVENT };
